export enum SerialType {
    Serial = 0,
    Activation =2,
    Residual =3 ,
    Commission = 4 ,
    Spiff = 5
}

export const  popupOpeningFields : string[] = [
    'transferNumber', 'invoiceNumber', 'salesOrderNumber', 'accountName', 
    'creditMemoNumber', 'adjustmentNumber', 'billNumber', 'itemReceiptNumber', 
    'purchaseNumber', 'rmaNumber', 'warehouseName', 'vendorName', 
    'vendorCreditNumber', 'vendorRMANumber'
  ];